/**
 * Public Sign Up CTA variant (W.4.57, selected by W.4.72).
 *
 * When this is the selected marketing variant, Clerk opens the hosted signup
 * modal and returns the visitor to the current page. This href is the no-Clerk
 * fallback and the destination recorded in analytics.
 */
import { appUrl } from './brand';

export const PUBLIC_SIGNUP_CTA = {
  label: 'Sign Up',
  get href() {
    return appUrl('/sign-up');
  },
};
